import { RateCardAssignmentStatus } from "client/api-v2";

export const RATE_CARD_STATUS_COLOR: Record<RateCardAssignmentStatus, "default" | "success" | "info"> = {
  [RateCardAssignmentStatus.Draft]: "info",
  [RateCardAssignmentStatus.Active]: "success",
  [RateCardAssignmentStatus.Superseded]: "default",
};
